/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Col, Container, Row, Table, Card } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Breadcrumb from '../../../components/Label/Breadcrumb'
import { convertDateWithTime } from '../../../helpers/constants'
import Loading from '../../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'
const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}
function DetailMaterialTransfer() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [filter, setFilter] = useState(null)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const fetchData = async () => {
    try {
      setLoading(true)
      if (!state) {
        throw new Error('Data not found')
      }
      const { filter, data } = state
      setFilter(filter)
      setData(data)
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/arrival/material-transfer')
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  useEffect(() => {
    fetchData()
  }, [state])

  if (loading) {
    return <Loading />
  }
  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row className="mb-4">
        <Col md={12}>
          <Breadcrumb
            label={data?.name}
            link="/arrival/material-transfer"
            back="MATERIAL TRANSFER"
            status=""
            type=""
            stateValue={filter}
          />
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row>
          <Col xs={12} md={2} lg={2}>
            <small style={labelStyle}>PLAN DATE</small>
            <h5 className="mt-1" style={{ fontSize: '1.1rem' }}>
              {convertDateWithTime(data?.plan_date, 'DD-MM-YYYY')}
            </h5>
          </Col>
          <Col xs={12} md={2} lg={3}>
            <small style={labelStyle}>DESTINATION WAREHOUSE</small>
            <h5 className="mt-1" style={{ fontSize: '1.1rem' }}>
              {data?.destination}
            </h5>
          </Col>
        </Row>
      </Card>

      <Card style={cardFilterStyle}>
        <Row>
          <Col md={12} className="mb-3">
            <h5 style={headerTitleStyle}>Items</h5>
          </Col>
          <Col md={12}>
            <Table
              hover
              responsive
              className="shadow-sm bg-white"
              style={{
                fontSize: '0.9rem',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: 0
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Code - Name
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Total Qty
                  </th>
                  <th
                    className="p-2 text-end align-middle"
                    style={tableHeaderStyle}
                  >
                    Total Pack
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.map((item, index) => (
                  <tr key={index}>
                    <td className="p-2 align-middle" style={{ width: '3%' }}>
                      {index + 1}
                    </td>
                    <td className="p-2 align-middle">
                      {item.item_code} - {item.item_name}
                    </td>
                    <td className="p-2 align-middle text-end">{`${item.qty} ${item.uom}`}</td>
                    <td className="p-2 align-middle text-end">{`${item.total_pack} ${item.uom_pack}`}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default DetailMaterialTransfer
